module.exports = __webpack_public_path__ + "static/media/Desafio4-c.cd5310bd.mp4";